<template>
	<div class="icon-whatsapp">
		<svg
			width="28.000000"
			height="28.000000"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs />
			<path
				id="path"
				d="M0 27.46C0 27.64 0.12 27.84 0.27 27.92C0.34 27.96 0.46 28 0.54 28C0.62 27.99 2.01 27.52 3.63 26.94L6.59 25.88L6.86 26.04C7.98 26.7 9.77 27.41 10.97 27.67C15.69 28.68 20.5 27.28 23.89 23.92C26.06 21.76 27.44 18.96 27.92 15.76C28.03 15.01 28.02 12.86 27.89 12.07C27.54 9.8 26.81 7.9 25.61 6.13C23.34 2.78 19.85 0.64 15.76 0.07C15.08 -0.03 12.94 -0.03 12.25 0.07C9.08 0.51 6.3 1.87 4.1 4.07C1.9 6.28 0.56 9.02 0.09 12.26C-0.02 13.01 0 15.11 0.12 15.93C0.25 16.76 0.58 18.07 0.84 18.77C1.04 19.33 1.7 20.7 2.03 21.27L2.21 21.58L1.1 24.45C0.49 26.03 -0.01 27.38 0 27.46ZM18.71 20.86C19.25 20.68 19.66 20.42 20.05 20.03C20.47 19.63 20.74 19.18 20.93 18.61C21.07 18.21 21.08 18.13 21.06 17.4C21.04 16.71 21.03 16.61 20.93 16.5C20.87 16.43 20.23 16.08 19.51 15.72C18.28 15.1 18.17 15.06 17.81 15.04C17.19 15 16.54 15.28 15.87 15.88L15.56 16.16L15.1 15.94C13.73 15.26 12.75 14.29 12.08 12.96L11.82 12.44L12.19 11.99C12.39 11.75 12.64 11.36 12.74 11.14C12.91 10.77 12.93 10.68 12.94 10.26L12.94 9.79L12.27 8.47C11.85 7.64 11.55 7.11 11.46 7.04C11.32 6.93 11.24 6.92 10.53 6.92C9.98 6.92 9.67 6.94 9.46 7.01C8.3 7.35 7.36 8.33 7.05 9.53C6.78 10.61 7.01 11.7 7.87 13.41C8.99 15.61 10.34 17.29 11.9 18.45C13.55 19.68 15.48 20.68 16.74 20.96C17.29 21.09 18.2 21.04 18.71 20.86Z"
				fill="#25D366"
				fill-opacity="1.000000"
				fill-rule="evenodd"
			/>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconWhatsApp extends Vue {}
</script>

<style scoped lang="scss">
.icon-whatsapp {
	display: flex;
}
</style>
